import { CmpMemberDashboardAccessReturn } from '../../../../graphql/types';
import { RedirectUri } from '../../../enumStrings';

/** Accounts Payable logins on CMP chambers can view and pay invoices, but cannot manage the profile. */
export const isInvoicesOnlyMemberAccess = (access?: CmpMemberDashboardAccessReturn | null): boolean =>
  Boolean(access?.cmpEnabled && access.canViewInvoices && !access.canManageProfile);
export const INVOICES_ONLY_LOGIN_NOTE = "This login can view and pay invoices only. To update your company profile, sign in with your company's main member login or contact the chamber.";

export const canUseMemberRoute = (route: string, access?: CmpMemberDashboardAccessReturn | null): boolean => {
  if (!access) return false;
  if (route === RedirectUri.memberInvoices) return access.cmpEnabled && access.canViewInvoices;
  if (access.cmpEnabled && !access.canManageProfile) return false;
  return true;
};
export const memberInvoiceIdentityKey = (userId: string, chamberId: string, memberId: string, contactId?: string | null): string =>
  JSON.stringify([userId, chamberId, memberId, contactId]);
